{
  "name": "plasma-games-angular",
  "author": {
    "name": "Plasma Games",
    "url": "https://play.plasma.games"
  },
  "version": "2026.9.0",
  "engines": {
    "npm": ">=10.0.0 <12.0.0",
    "node": ">=22.15.0 <24.0.0"
  },
  "scripts": {
    "start": "node server.js",
    "build": "node scripts/heroku-build",
    "build:debug": "npm run ng -- build --configuration=production --source-map",
    "build:version": "node --experimental-json-modules scripts/version.js",
    "build:github": "node scripts/github-build.js",
    "bundle-report": "webpack-bundle-analyzer dist/plasma-games-angular/stats.json",
    "cy": "cypress open",
    "cy:debug": "DEBUG=cypress:* cypress open",
    "cy:clear-cache": "cypress cache clear",
    "cy:install": "cypress install",
    "cy:report": "node scripts/cy-report.js",
    "cy:serve": "static-server ./cypress/reports/html 7200",
    "docker:build": "node scripts/docker/docker-build.js",
    "docker:run": "node scripts/docker/docker-run.js",
    "e2e": "npm run ng -- e2e --port 6200",
    "generate:component": "ng generate @sbpro/ng:component",
    "generate:directive": "ng generate @sbpro/ng:directive",
    "generate:module": "ng generate @sbpro/ng:module",
    "generate:service": "ng generate @sbpro/ng:service",
    "lint": "npm run ng -- lint",
    "lint:fix": "npm run ng -- lint --fix",
    "ng": "cross-env NODE_OPTIONS=--max_old_space_size=4096 ./node_modules/.bin/ng",
    "local-start:clean": "rm -rf ./node_modules/ ./dist/ && npm install && npm run local-start",
    "serve": "static-server dist/plasma-games-angular",
    "serve:coverage": "static-server ./coverage/plasma-games-angular 9753",
    "source-map-analyzer": "ng build --configuration=production --source-map && source-map-explorer dist/plasma-games-angular/browser/main-*.js",
    "source-map-explorer": "source-map-explorer dist/plasma-games-angular/browser/main-*.js",
    "local-start": "node scripts/start.js",
    "start-ubuntu": "node scripts/start-ubuntu.js",
    "test": "npm run ng -- test --watch=false --code-coverage --browsers=ChromeHeadlessNoSandbox",
    "test:dev": "node scripts/test-dev.js",
    "test:hsts": "node --test scripts/hsts.config.spec.js",
    "version": "node --experimental-json-modules scripts/version",
    "codegen": "graphql-codegen --config codegen.yml",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org plasma-games --project javascript-angular ./dist/plasma-games-angular/browser && sentry-cli sourcemaps upload --org plasma-games --project javascript-angular ./dist/plasma-games-angular/browser",
    "storybook": "ng run plasma-games-angular:storybook",
    "build-storybook": "ng run plasma-games-angular:build-storybook --stats-json",
    "chromatic": "npx chromatic"
  },
  "private": true,
  "type": "module",
  "overrides": {
    "@cypress/request": "3.0.8",
    "graphql-ws": "5.16.2",
    "esbuild": "0.25.1",
    "@angular-devkit/core": "18.2.21",
    "@angular-devkit/architect": "0.1802.21"
  },
  "dependencies": {
    "@amplitude/analytics-browser": "2.10.0",
    "@angular/animations": "18.2.13",
    "@angular/cdk": "18.2.13",
    "@angular/common": "18.2.13",
    "@angular/compiler": "18.2.13",
    "@angular/core": "18.2.13",
    "@angular/forms": "18.2.13",
    "@angular/localize": "18.2.13",
    "@angular/platform-browser": "18.2.13",
    "@angular/platform-browser-dynamic": "18.2.13",
    "@angular/router": "18.2.13",
    "@apollo/client": "3.12.3",
    "@awesome.me/kit-55ca5fc4e1": "1.0.350",
    "@cypress/webpack-dev-server": "4.1.0",
    "@fortawesome/angular-fontawesome": "^0.15.0",
    "@ion-phaser/core": "1.3.0",
    "@json2csv/plainjs": "^7.0.6",
    "@kolkov/angular-editor": "3.0.0-beta.0",
    "@ng-bootstrap/ng-bootstrap": "17.0.1",
    "@ngxs/devtools-plugin": "18.1.6",
    "@ngxs/logger-plugin": "18.1.6",
    "@ngxs/router-plugin": "18.1.6",
    "@ngxs/storage-plugin": "18.1.6",
    "@ngxs/store": "18.1.6",
    "@popperjs/core": "2.11.8",
    "@primeng/themes": "^19.1.0",
    "@sentry/angular": "^10.10.0",
    "angular-feather": "6.5.1",
    "angular-google-tag-manager": "1.10.0",
    "aos": "2.3.4",
    "apollo-angular": "7.2.1",
    "chart.js": "3.9.1",
    "copy-to-clipboard": "3.3.3",
    "cross-env": "7.0.3",
    "date-fns": "3.6.0",
    "device-detector-js": "3.0.3",
    "exceljs": "^4.4.0",
    "express": "4.21.2",
    "graphql": "16.9.0",
    "graphql-tools": "9.0.1",
    "helmet": "^8.1.0",
    "jquery": "3.7.1",
    "just-compare": "2.3.0",
    "lity": "2.4.1",
    "lodash": "4.17.21",
    "mdb-angular-ui-kit": "git+https://oath2:qsZxKa4239R5ivzJFBRH@git.mdbootstrap.com/mdb/angular/mdb5/prd/mdb5-angular-ui-kit-pro-essential.git#7.1.0",
    "mdb-angular-wysiwyg": "git+https://oauth2:pU4uZX8eFJ98BWGWS6v-@git.mdbootstrap.com/mdb/angular/mdb5/plugins/prd/wysiwyg.git#7.1.0",
    "moment": "2.30.1",
    "ngx-clipboard": "16.0.0",
    "ngx-cookie-service": "18.0.0",
    "ngx-device-detector": "8.0.0",
    "ngx-easy-table": "15.6.0",
    "ngx-extended-pdf-viewer": "^23.3.1",
    "ngx-quill": "26.0.10",
    "ngx-spinner": "16.0.2",
    "ngx-ui-switch": "15.0.0",
    "ngx-ui-tour-core": "13.0.0",
    "ngx-ui-tour-ng-bootstrap": "15.0.0",
    "ngxs-reset-plugin": "4.0.0",
    "object-hash": "3.0.0",
    "parchment": "3.0.0",
    "phaser": "3.55.2",
    "primeng": "18.0.2",
    "prismjs": "1.30.0",
    "rxjs": "7.8.1",
    "scriptjs": "^2.5.9",
    "subsink": "^1.0.2",
    "tslib": "2.6.3",
    "uuid": "8.3.2",
    "webpack-bundle-analyzer": "4.10.2",
    "zone.js": "0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "18.2.18",
    "@angular/cli": "18.2.18",
    "@angular/compiler-cli": "18.2.13",
    "@angular/language-service": "18.2.13",
    "@cypress/webpack-preprocessor": "6.0.2",
    "@graphql-codegen/cli": "5.0.2",
    "@graphql-codegen/introspection": "4.0.3",
    "@graphql-codegen/typescript": "4.0.9",
    "@graphql-codegen/typescript-apollo-angular": "4.0.0",
    "@graphql-codegen/typescript-operations": "4.2.3",
    "@inip/static-server": "1.0.1",
    "@sbpro/ng": "3.1.0",
    "@storybook/addon-docs": "10.2.15",
    "@storybook/addon-onboarding": "10.2.15",
    "@storybook/angular": "10.2.15",
    "@types/aos": "3.0.7",
    "@types/chart.js": "2.9.41",
    "@types/cypress": "1.1.6",
    "@types/jasmine": "5.1.4",
    "@types/jasminewd2": "2.0.13",
    "@types/lodash": "4.17.7",
    "@types/mocha": "10.0.6",
    "@types/node": "22.15.1",
    "@types/node-fetch": "2.6.11",
    "@types/object-hash": "3.0.6",
    "@types/prismjs": "1.26.3",
    "@types/quill": "2.0.14",
    "@types/scriptjs": "0.0.5",
    "@types/uuid": "9.0.8",
    "@types/webpack-env": "1.18.4",
    "bootstrap": "5.2.3",
    "chromatic": "^12.0.0",
    "concurrently": "8.2.2",
    "cross-env": "7.0.3",
    "cypress": "^14.5.0",
    "cypress-file-upload": "5.0.8",
    "cypress-multi-reporters": "2.0.4",
    "dotenv": "16.4.5",
    "jasmine-core": "5.2.0",
    "jasmine-spec-reporter": "7.0.0",
    "karma": "6.4.4",
    "karma-chrome-launcher": "3.2.0",
    "karma-coverage-istanbul-reporter": "3.0.3",
    "karma-jasmine": "5.1.0",
    "karma-jasmine-html-reporter": "2.1.0",
    "mocha": "10.7.3",
    "mochawesome": "7.1.3",
    "mochawesome-json-to-md": "^1.3.5",
    "mochawesome-merge": "4.3.0",
    "mochawesome-report-generator": "6.2.0",
    "prettier": "3.3.3",
    "shelljs": "0.8.5",
    "storybook": "10.2.15",
    "ts-loader": "9.5.1",
    "ts-node": "10.9.2",
    "typescript": "5.5.4"
  }
}
